module.exports = __webpack_public_path__ + "static/media/ic_04_trafficmonitoring.185726e1.svg";